import React from 'react';
import { Box } from '@mui/material';
import { DirigeantPPWidget, DirigeantPPWidgetType } from '../../molecules';

export type DirigeantPPListProps = {
    items?: Array<DirigeantPPWidgetType>;
};

export const DirigeantPPList: React.FunctionComponent<DirigeantPPListProps> = function (
    props: DirigeantPPListProps,
) {
    const { items } = props;
    return (
        <Box>
            {items
                ? items.map((itemProps: DirigeantPPWidgetType, index) => (
                      <DirigeantPPWidget
                          key={`dirigeantPP-${itemProps.dirigeantPP.individu.descriptionPersonne.nom}-${itemProps.dirigeantPP.individu.descriptionPersonne.prenoms}}`}
                          {...itemProps}
                          index={index}
                      />
                  ))
                : null}
        </Box>
    );
};
